<template>
    <div class="container">
        <div class="pt-5">
            <h1 class="h3">Settings</h1>
            <div class="py-2">

                <settings-menu></settings-menu>
            </div>
            <div class="row py-3 border-bottom">
                    <div class="col-md-6 col-sm-12">
            <h3 class="h3 text-primary">Inventory and Orders settings</h3>
            <small>View and update your store details </small>
            </div>
            <div class="col-md-6 col-sm-12">
                <div class="float-right">
                    <button @click="saveInventorySettings" class="btn btn-primary px-3">Save Changes</button>
                </div>
                </div>
                </div>

                <div class="container text-left mb-5">
                    <div class="row py-3 border-bottom">
                        <div class="col-md-6 col-sm-12">
                            <h6 class="py-1">Feature toggles</h6>
                            <small>
                                  Stock Buffer, Borrowed Stock, Wholesale, Pack/Dispatch, Returns, Courier Tracking,
                                  employee visibility permissions and other feature switches have moved to
                                  <a href="/settings/features">Settings &gt; Features</a>.
                                </small>
                        </div>
                    </div>

                <div class="row py-3 border-bottom">
                    <div class="col-md-6 col-sm-12">
                        <h6 class="py-1">Minimum Stock</h6>
                        <small>
                              General stock low limit. Only applies if Stock Alerts is enabled under
                              <a href="/settings/features">Settings &gt; Features</a>.
                            </small>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <input type="number" v-model="inventorySettings.minimums_stock" class="form-control" />
                        <small>You can change for individual item on the <a href="/products">inventory page</a></small>
                    </div>
                </div>
                <div class="row py-3 border-bottom">
                    <div class="col-md-6 col-sm-12">
                        <h6 class="py-1">Receipt settings</h6>
                        <small>
                              Order/receipt numbering prefix, starting number and print limit have moved to
                              <a href="/settings/receipt">Settings &gt; Customization</a>.
                            </small>
                    </div>
                </div>
                <hr/>
                <!-- <div class="container">
                     <div class="float-right">
                         <button @click="saveInventorySettings" class="btn btn-primary px-3">Save Changes</button>
                </div> -->
            <!-- </div> -->
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "profile",
        data() {
            return {
                inventorySettings: {

                }
            }
        },
        mounted() {
            this.getUserCompanySettings()
        },
        methods: {

            async getUserCompanySettings() {
                await axios.get('/api/settings')
                    .then(results => {

                       this.inventorySettings = results.data


                    }).catch(errors => {
                        console.log(errors.message)
                    });
            },
            saveInventorySettings() {
                axios.post('/api/settings/inventory', { ...this.inventorySettings
                }).then(results => {
                    if(results.status === 200)
                    {
                        this.$toasts.push({
                        type: 'success',
                        message: "Settings updated"
                         })
                         window.location.reload()
                    }

                }).catch(errors => {
                })
            }
        },
    }
</script>

<style scoped>

</style>
